module.exports = __webpack_public_path__ + "img/service-qrcode.68065e19.jpg";